import React, { useState, useContext, useEffect } from "react";
import "./StepThree.scss";
import Head from "../Head/Head";
import Squares from "../Squares/Squares";
import Text from "../Text/Text";
import Elements from "../Elements/Elements";

import { SquareContext } from "../../SquareContext";
import thickred from "../../assets/thickred.svg";

function StepThree(props) {
  // const [isChecked, setIsChecked] = useState(false);
  const {
    listUnits,
    cartItems,
    unitImg,
    unitName,
    listUnits2,
    listUnits3,
    btnColor2,
    setBtnColor2,
    activeColor,
    unit,
    initialColor,
    checked,
    checked2,
    checked3,
    checked4,
    checked5,
    checked6,
    checked7,
    checked8,
    checked9,
    stepDesc,
    cart,
  } = useContext(SquareContext);

  const [chamber, setChamber] = useState(false);
  const [chamber2, setChamber2] = useState(false);
  const [chamber3, setChamber3] = useState(false);
  const [btnColor3, setBtnColor3] = useState(initialColor);

  useEffect(() => {
    if (checked === true || checked2 === true || checked7 === true) {
      setChamber(true);
    } else {
      setChamber(false);
    }
    if (checked3 === true || checked4 === true || checked8 === true) {
      setChamber2(true);
    } else {
      setChamber2(false);
    }
    if (checked5 === true || checked6 === true || checked9 === true) {
      setChamber3(true);
    } else {
      setChamber3(false);
    }
  }, [
    checked,
    checked2,
    checked3,
    checked4,
    checked5,
    checked6,
    checked7,
    checked8,
    checked9,
  ]);

  // if(!cartItems[1]  && chamber === true){
  //   setBtnColor3(activeColor);
  // }else if(cartItems[1] && chamber === true && chamber2 === true) {
  //   setBtnColor3(activeColor)
  // }

  // if(cartItems[1] && chamber === true && chamber2 === true){
  //   setBtnColor3(activeColor)
  // }else {
  //   setBtnColor3(initialColor)
  // }

  useEffect(() => {
    if (cartItems[0] && !cartItems[1] && !cartItems[2] && chamber === true) {
      setBtnColor3(activeColor);
    } else if (
      cartItems[0] &&
      !cartItems[1] &&
      !cartItems[2] &&
      chamber === false
    ) {
      setBtnColor3(initialColor);
    } else if (
      cartItems[0] &&
      cartItems[1] &&
      !cartItems[2] &&
      chamber === true &&
      chamber2 === true
    ) {
      setBtnColor3(activeColor);
    } else if (
      (cartItems[0] && cartItems[1] && !cartItems[2] && chamber === false) ||
      chamber2 === false
    ) {
      setBtnColor3(initialColor);

      // }else if (cartItems[0] && cartItems[1] && cartItems[2] && (chamber === true && chamber2 === true && chamber3 === true)){
      //   setBtnColor3(activeColor);
      // }else if (cartItems[0] && cartItems[1] && cartItems[2]){
      //   setBtnColor3(initialColor);
    } else if (
      cartItems[0] &&
      cartItems[1] &&
      cartItems[2] &&
      chamber === true &&
      chamber2 === true &&
      chamber3 === true
    ) {
      setBtnColor3(activeColor);
    } else if (
      (cartItems[2] && chamber === false) ||
      chamber2 === false ||
      chamber3 === false
    ) {
      setBtnColor3(initialColor);
    }

    // if( cartItems[0] && cartItems[1] && !cartItems[2] && chamber === true && chamber2 === true){
    //   setBtnColor3(activeColor);
    // }else {
    //   setBtnColor3(initialColor)
    // }
  }, [cartItems, chamber, chamber2, chamber3]);

  useEffect(() => {
    if (cart.length === 0) {
      props.jump(1);
    }
  }, [cart]);

  function handleNext() {
    if (btnColor3 === activeColor) {
      props.next();
    }
  }

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="stepThree">
    

        {stepDesc[2] && (
        <div>
  
          <div className="head">
            <p className="head-red">STEP 3</p>
            <p className="head-line">I</p>
            <p  dangerouslySetInnerHTML={{ __html: stepDesc[2].title }}></p>
          </div>
        </div>
      )}

        <div className="stone">
          <Squares
            first={() => {
              if (props.order === 3) {
                props.jump(1);
              } else {
                props.jump(3);
              }
            }}
            second={() => {
              if (props.order === 3) {
                props.jump(1);
              } else {
                props.jump(3);
              }
            }}
            third={() => {
              if (props.order === 3) {
                props.jump(1);
              } else {
                props.jump(3);
              }
            }}
          />
          {stepDesc[2] !== undefined && (
            <div className="text-middle"
            dangerouslySetInnerHTML={{ __html: stepDesc[2].description }}
            >
              {/* <Text desc={stepDesc[2] !== undefined && stepDesc[2].description} /> */}
            </div>
          )}
          <div className="buttons">
              <button
                className="btn-prev"
                onClick={props.prev}
                style={{ background: "#ff262d" }}
              >
                BACK STEP
              </button>
              <button
                className="btn-next"
                onClick={handleNext}
                style={{ background: btnColor3 }}
              >
                NEXT STEP
              </button>
            </div>
        </div>
        <div className="shapes">
          <Elements eleclass="elements34" />
          <div className="cont-step3">
            <div className="shapes-form-container-step3">
              <div className="shapes-form-step3">
                {cartItems[0] && (
                  <div className="shape-input">
                    <div className="shape-img">
                      {unitImg[0]}
                      {unitName[0]}
                    </div>
                    {listUnits[0]}
                    <img className="thickdot" src={thickred} alt="reddot" />
                  </div>
                )}
                {cartItems[1] && (
                  <div className="shape-input">
                    <div className="shape-img">
                      {unitImg[1]}
                      {unitName[1]}
                    </div>
                    {listUnits2[1]}
                    <img className="thickdot" src={thickred} alt="reddot" />
                  </div>
                )}
                {cartItems[2] && (
                  <div className="shape-input">
                    <div className="shape-img">
                      {unitImg[2]}
                      {unitName[2]}
                    </div>
                    {listUnits3[2]}
                    <img className="thickdot" src={thickred} alt="reddot" />
                  </div>
                )}
              </div>
            </div>
            <div className="buttons btn-dwn3">
              <button
                className="btn-prev"
                onClick={props.prev}
                style={{ background: "#ff262d" }}
              >
                BACK STEP
              </button>
              <button
                className="btn-next"
                onClick={handleNext}
                style={{ background: btnColor3 }}
              >
                NEXT STEP
              </button>
            </div>
          </div>
        </div>
     
      </div>
    </>
  );
}

export default StepThree;
